import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "@css/app.scss";
import "@css/tailwind.css";
import configureStore from "./configureStore";
import App from "@app/containers/App";
import { urlParam, isAlphaFlow } from "utils/helpers";
import { storeUrlParams, clearLocalStorage } from "utils/localStorage";
import CleverTapAnalytics from "analytics/type/CleverTapAnalytics";
import { LEGACY_APP_ENABLED } from "utils/constants";

const { persistor, store } = configureStore();

const conditionToRenderAlpha =
  !LEGACY_APP_ENABLED ||
  localStorage.getItem("alpha") ||
  urlParam("alpha") ||
  isAlphaFlow();

if (conditionToRenderAlpha) {
  if (urlParam("reset") === "true") {
    clearLocalStorage();
    persistor.purge();
    // Clear Old CleverTap ID to maintain unique users
    CleverTapAnalytics.clearOldCleverTapID();
    window.dataLayer = [];
  }

  storeUrlParams();

  ReactDOM.render(
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <App persistor={persistor} store={store} />
      </PersistGate>
    </Provider>,
    document.getElementById("root")
  );
}
